var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasswordInput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4955 0.0411754C14.1269 0.0411754 17.0843 2.88504 17.0843 6.38067L17.0842 8.26614C19.2919 9.00498 20.8801 11.0261 20.8801 13.398V18.5273C20.8801 21.523 18.3468 23.9591 15.2314 23.9591H5.72872C2.61339 23.9591 0.0800781 21.523 0.0800781 18.5273V13.398C0.0800781 11.0265 1.66762 9.00575 3.8747 8.26656L3.87557 6.38067C3.88303 4.65857 4.57574 3.06921 5.8256 1.87809C7.07671 0.685769 8.72828 -0.00426905 10.4955 0.0411754ZM15.2314 9.76007H5.72872C3.64188 9.76007 1.94555 11.3913 1.94555 13.398V18.5273C1.94555 20.534 3.64188 22.1652 5.72872 22.1652H15.2314C17.317 22.1652 19.0146 20.534 19.0146 18.5273V13.398C19.0146 11.3913 17.317 9.76007 15.2314 9.76007ZM10.4798 13.7374C10.9947 13.7374 11.4126 14.1392 11.4126 14.6343V17.2904C11.4126 17.7856 10.9947 18.1874 10.4798 18.1874C9.96496 18.1874 9.54709 17.7856 9.54709 17.2904V14.6343C9.54709 14.1392 9.96496 13.7374 10.4798 13.7374ZM10.4918 1.83503H10.4719C9.21206 1.83503 8.03183 2.30144 7.14014 3.15173C6.24223 4.0056 5.74601 5.1453 5.74104 6.36034L5.73992 7.96553H15.2178L15.2189 6.38067C15.2189 3.87406 13.0985 1.83503 10.4918 1.83503Z",
    fill: "#767676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordInput);
export default __webpack_public_path__ + "static/media/passwordInput.e4db7a4428c8e02a275de9c3c77fd0e6.svg";
export { ForwardRef as ReactComponent };